import React from 'react';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// Medical / lab / hospital images from Pexels (medical equipment, laboratory, healthcare)
const PEXELS_IMAGES = [
  'https://images.pexels.com/photos/7089029/pexels-photo-7089029.jpeg?auto=compress&cs=tinysrgb&w=600', // medical scan / ultrasound
  'https://images.pexels.com/photos/3825377/pexels-photo-3825377.jpeg?auto=compress&cs=tinysrgb&w=600', // laboratory testing
  'https://images.pexels.com/photos/7722927/pexels-photo-7722927.jpeg?auto=compress&cs=tinysrgb&w=600', // medical supplies
  'https://images.pexels.com/photos/7089024/pexels-photo-7089024.jpeg?auto=compress&cs=tinysrgb&w=600', // medical equipment
];

const AboutWhoWeAre: React.FC = () => (
  <section className="bg-white py-24 md:py-32 border-b border-gray-100">
    <div className="container-main grid md:grid-cols-12 gap-8 md:gap-16 items-start">
      <div className="md:col-span-4 lg:col-span-3">
        <h2 className="text-[#2980b9] font-bold text-xl tracking-widest uppercase">Who We Are</h2>
      </div>
      
      <div className="md:col-span-8 lg:col-span-9 flex flex-col lg:flex-row gap-12">
        <div className="flex-1">
          <p className="text-gray-900 text-2xl font-light leading-snug mb-6">
            Expertise, Discipline and Precision
          </p>
          <p className="text-gray-600 text-lg font-light leading-relaxed mb-6">
            Our aim is to grow with the medical supplies and mining industry, to create a name for ourselves
            in the market by giving our customers quality products at a price that will be competitive.
          </p>
          <p className="text-gray-600 font-light leading-relaxed mb-6">
            We are the most efficient surgical equipment, dental equipment, electrosurgical equipment,
            diagnostics kits and laboratory equipment suppliers in Zimbabwe. Manlab Medicals Incorporated exports to any country within Africa. Our products include Loop Electrodes,
            Graves Speculums, Blood Lead Analyzers, ELISA Reagents, Surgical Equipment, Mining Chemicals and more.
          </p>
          <Link to="/contact" className="inline-flex items-center text-[#2980b9] font-bold hover:text-gray-900 transition-colors uppercase tracking-widest text-sm mb-8 lg:mb-0">
            Get A Quote <ArrowForwardIcon fontSize="small" className="ml-2" />
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4 flex-shrink-0 w-full lg:w-[380px]">
          {PEXELS_IMAGES.map((src, i) => (
            <div key={i} className="rounded-2xl overflow-hidden shadow-md border border-gray-100 bg-gray-50 aspect-square min-h-[180px] md:min-h-[220px]">
              <img
                src={src}
                alt=""
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default AboutWhoWeAre;
